<template>
  <div class="shisanwu">
    <div class="body-content">
      <div class="breadcrumb-box">
        <div class="breadcrumb-body">
          <span class="pointer" @click="toHome">首页</span>
          <span>>></span>
          <span>十三五</span>
        </div>
      </div>
      <div class="title">聚焦十三五</div>
      <div class="search-box">
        <input type="text" placeholder="请输入相关字段，点击搜索">
        <span class="search-btn">搜索</span>
      </div>
      <div class="show-list">
        <div class="name">成就展</div>
        <ul>
          <li
            v-for="(item, index) in achievementList"
            :key="index"
            @click="toArticle(0, index)"
          >
            <div class="image">
              <img class="bg" :src="item.img" alt="">
              <div class="mask">
                <img class="play-icon" src="../../assets/images/shisanwu/编组 10@2x.png" alt="">
              </div>
            </div>
            <span class="text">{{item.text}}</span>
          </li>
        </ul>
      </div>
      <div class="show-list">
        <div class="name">试验装置/系统</div>
        <ul>
          <li
            v-for="(item, index) in testerList"
            :key="index"
            @click="toArticle(12, index)"
          >
            <div class="image">
              <img class="bg" :src="item.img" alt="">
              <div class="mask">
                <img class="play-icon" src="../../assets/images/shisanwu/编组 10@2x.png" alt="">
              </div>
            </div>
            <span class="text">{{item.text}}</span>
          </li>
        </ul>
      </div>
      <div class="show-list">
        <div class="name">检测设备/仪器</div>
        <ul>
          <li
            v-for="(item, index) in testEquipmentList"
            :key="index"
            @click="toArticle(20, index)"
          >
            <div class="image">
              <img class="bg" :src="item.img" alt="">
              <div class="mask">
                <img class="play-icon" src="../../assets/images/shisanwu/编组 10@2x.png" alt="">
              </div>
            </div>
            <span class="text">{{item.text}}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      achievementList: [
        {
          img: require('../../assets/images/shisanwu/矩形@2x(2).png'),
          text: '直接接入式直流电能表检定装置'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(3).png'),
          text: '培养研究生5人'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x.png'),
          text: '硕士研究生人才培养'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(1).png'),
          text: '经济性结构风险预警技术研究'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(6).png'),
          text: '近海简易风电基础结构设计研究'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(7).png'),
          text: '培养研究生5人'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(4).png'),
          text: '硕士研究生人才培养'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(5).png'),
          text: '经济性结构风险预警技术研究'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(26).png'),
          text: '近海简易风电基础结构设计研究'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(27).png'),
          text: '培养研究生5人'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(24).png'),
          text: '硕士研究生人才培养'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(25).png'),
          text: '经济性结构风险预警技术研究'
        }
      ],
      testerList: [
        {
          img: require('../../assets/images/shisanwu/矩形@2x(10).png'),
          text: '近海简易风电基础结构设计研究'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(11).png'),
          text: '培养研究生5人'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(8).png'),
          text: '硕士研究生人才培养'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(9).png'),
          text: '经济性结构风险预警技术研究'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(14).png'),
          text: '近海简易风电基础结构设计研究'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(15).png'),
          text: '培养研究生5人'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(12).png'),
          text: '硕士研究生人才培养'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(13).png'),
          text: '经济性结构风险预警技术研究'
        }
      ],
      testEquipmentList: [
        {
          img: require('../../assets/images/shisanwu/矩形@2x(2).png'),
          text: '近海简易风电基础结构设计研究'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(19).png'),
          text: '培养研究生5人'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(16).png'),
          text: '硕士研究生人才培养'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(17).png'),
          text: '经济性结构风险预警技术研究'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(22).png'),
          text: '近海简易风电基础结构设计研究'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(23).png'),
          text: '培养研究生5人'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(20).png'),
          text: '硕士研究生人才培养'
        },
        {
          img: require('../../assets/images/shisanwu/矩形@2x(21).png'),
          text: '经济性结构风险预警技术研究'
        }
      ]
    }
  },
  methods: {
    toHome () {
      this.$router.push('/')
    },
    toArticle (count, index) {
      const type = (count + index) % 8
      this.$router.push({ path: '/article', query: { type: type } })
    }
  }
}
</script>

<style lang="less" scoped>
.body-content {
  width: @body-width;
  margin: 0 auto;
}
.pointer {
  cursor: pointer;
}
.shisanwu {
  .breadcrumb-box {
    margin-bottom: 24px;
    padding-top: 12px;
    .breadcrumb-body {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 17px;
      span {
        margin-right: 7px;
      }
    }
  }
  .title {
    margin-bottom: 32px;
    font-size: 24px;
    font-weight: 500;
    line-height: 33px;
    color: rgba(0, 0, 0, 0.65);
    text-align: center;
  }
  .search-box {
    display: flex;
    margin-bottom: 32px;
    padding-left: 60px;
    input {
      margin-right: 24px;
      width: 980px;
      height: 52px;
      outline: none;
      border: 1px solid rgba(0, 0, 0, 0.1);
      padding-left: 26px;
      box-sizing: border-box;
    }
    .search-btn {
      width: 120px;
      height: 52px;
      line-height: 52px;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      background-color: rgba(46, 92, 154, 1);
      cursor: pointer;
    }
  }
  .show-list {
    padding-bottom: 8px;
    &:last-child {
      padding-bottom: 36px;
    }
    .name {
      display: inline-block;
      margin-bottom: 16px;
      padding-bottom: 6px;
      font-size: 18px;
      font-weight: 700;
      line-height: 25px;
      color: rgba(46, 92, 154, 1);
      border-bottom: 2px solid rgba(46, 92, 154, 1);
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        flex: 0 0 310px;
        margin-right: 12px;
        margin-bottom: 24px;
        &:nth-child(4n) {
          margin-right: 0;
        }
        .image {
          position: relative;
          margin-bottom: 16px;
          width: 100%;
          height: 240px;
          .bg {
            width: 100%;
            height: 100%;
          }
          .mask {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .29);
            .play-icon {
              position: absolute;
              left: 8px;
              bottom: 8px;
              z-index: 1;
              width: 24px;
              height: 24px;
            }
          }
        }
        .text {
          font-size: 16px;
          color: rgba(0, 0, 0, 0.85);
          line-height: 22px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/shisanwu/index.vue